import styled from 'styled-components';

export const ButtonTag = styled.button`
  position: initial;
  background-color: ${props => props.color};
  border-radius: 8px;
  padding: 6px 12px;
  margin: 5px 5px 0 0;
  font-weight: 700;
`;